import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import MetaTags from "react-meta-tags";
import i18next from "i18next";
import Sidebar from "../layouts/main/Sidebar";
import productsListStorage from "../storages/productsListStorage";
import ProductCardList from "../containers/ProductCard/ProductCardList";
import layoutStorage from "../storages/layoutStorage";
import Page from "../layouts/Page";
import Filters from "./ProductPageContent/Filters";
import CollectionControl from "./ProductPageContent/CollectionControl";
import Pagination from "./ProductPageContent/Pagination";
import ProductListPromoBlock from "./ProductPageContent/ProductListPromoBlock";
// import TrendingProducts from "./ProductPageContent/TrendingProducts";
// import FeaturedProducts from "../containers/Filters/FeaturedProducts";
// import CustomContent from "../containers/Filters/CustomContent";
// import PromoBlock from "../containers/Filters/PromoBlock";
// import useQueryParams from "../helpers/useQueryParams";
import BreadcrumbsBlock from "../UI/molecules/breadcrumbs/BreadcrumbsBlock";
import EditableText from "../UI/organisms/EditableText/EditableText";
import currentCategoryStorage from "../storages/currentCategoryStorage";
import filtersStorage from "../storages/filtersStorage";
import generateTitle from "../helpers/generateTitle";
import {
  generateH1Cat,
  generateH1CatWothoutFilters,
} from "../helpers/generateH1";
import generateDescription from "../helpers/generateDescription";
import globalStorage from "../storages/globalStorage";
import RelatedLinks from "../UI/atoms/links/RelatedLinks";
import Core from "../core/Core";
import AdditionalTextBlock from "../UI/atoms/blocks/AdditionalTextBlock";
import logger from "../helpers/logger";
import menuStorage from "../storages/menuStorage";

class Products extends Component {
  getLoading = () => ({
    // initial: false,
    // dictionaries: true,
    // additional: [],
  });

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (this.props.location.pathname !== prevProps.location.pathname) {
  //     currentCategoryStorage.loadTexts(this.props.location.pathname);
  //   }
  // }
  //
  // componentDidMount() {
  //   currentCategoryStorage.loadTexts(this.props.location.pathname);
  // }

  createMicroformat = () => {
    if (
      !productsListStorage.isLoaded ||
      !productsListStorage.productsList ||
      productsListStorage.productsList.length === 0 ||
      !productsListStorage.productsList[0]
    )
      return null;
    const jsonLdArray = productsListStorage.productsList.map((productID) => {
      const {
        price,
        vendor,
        refNum,
        sku,
        productTitle,
        currentImages,
        currentDescription,
      } = productsListStorage.products[productID];
      return {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: productTitle,
        image: currentImages
          ? currentImages.map((image, index) =>
              image.smallImageUrl.replace(/\/150\//, "/600/")
            )
          : [],
        description: currentDescription,
        sku,
        mpn: refNum,
        brand: {
          "@type": "Brand",
          name: vendor,
        },
        // review: {
        //   "@type": "Review",
        //   reviewRating: {
        //     "@type": "Rating",
        //     ratingValue: "4",
        //     bestRating: "5",
        //   },
        //   author: {
        //     "@type": "Person",
        //     name: "Fred Benson",
        //   },
        // },
        // aggregateRating: {
        //   "@type": "AggregateRating",
        //   ratingValue: "4.4",
        //   reviewCount: "89",
        // },
        offers: {
          "@type": "Offer",
          url: window.location.href,
          priceCurrency: "UAH",
          price: price / 100,
          priceValidUntil: "2020-11-20",
          itemCondition: "https://schema.org/NewCondition",
          availability: "https://schema.org/InStock",
        },
      };
    });
    // console.log("JSON+LD", jsonLdArray);
    // const scriptTag = document.getElementById("ldjsonscript");
    // if (!scriptTag) {
    //   const el = document.createElement("script");
    //   el.id = "ldjsonscript";
    //   el.type = "application/ld+json";
    //   el.innerText = JSON.stringify(jsonLdArray);
    //   document.getElementsByTagName("head").item(0).append(el);
    // } else {
    //   scriptTag.innerText = JSON.stringify(jsonLdArray);
    // }
  };

  render() {
    const { t } = this.props;
    const breadcrumbsItems = [];

    if (layoutStorage.currentCategory) {
      const parentCat = layoutStorage.parentCategory;
      if (parentCat && parentCat.id != 4) {
        const parentCatLink = Core.routing.createRoute(
          Core.routing.routingSegments.SEGMENT_CATALOG,
          {
            slug: parentCat[`slug_${layoutStorage.currentLanguage}`],
            full: true,
          }
        );
        breadcrumbsItems.push({
          title: parentCat[`name_${layoutStorage.currentLanguage}`],
          link: parentCatLink,
        });
      }
    }
    // this.createMicroformat();
    const urlParams = new URLSearchParams(window.location.search);
    let currentPage = urlParams.get("page");
    // if (!currentPage) {
    currentPage = productsListStorage.currentPage + 1;
    // }

    const h1WithoutFilters = generateH1CatWothoutFilters(
      currentCategoryStorage.texts.h1,
      currentCategoryStorage.categoryText,
      layoutStorage.currentCategory.title
    );

    const h1 = `${generateH1Cat(
      currentCategoryStorage.texts.h1,
      currentCategoryStorage.categoryText,
      layoutStorage.currentCategory.title
    )}`;
    const title = generateTitle(
      currentCategoryStorage.texts.metaTitle,
      h1,
      h1WithoutFilters,
      currentPage
    );
    const description = generateDescription(
      currentCategoryStorage.texts.metaDescription,
      h1,
      h1WithoutFilters,
      layoutStorage.company.phone
    );
    const firstProduct =
      productsListStorage.productsList.length > 0
        ? productsListStorage.productsList[0]
        : null;
    let image = null;
    if (firstProduct) {
      image = productsListStorage.products[firstProduct].mainImage;
    }
    return (
      <Page
        id="MainContent"
        className="productsPage"
        loadingConfig={this.getLoading()}
      >
        <MetaTags>
          <title>{title}</title>
          <meta
            name="description"
            content={currentPage <= 1 ? description : null}
          />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content={currentCategoryStorage.texts.ogTitle || title}
          />
          <meta
            property="og:description"
            content={
              currentCategoryStorage.texts.ogDescription ||
              currentCategoryStorage.texts.metaDescription ||
              description
            }
          />
          <meta
            property="og:url"
            content={currentCategoryStorage.texts.ogUrl || window.location.href}
          />
          <meta
            property="og:image"
            content={
              currentCategoryStorage.texts.ogImage ||
              (image ? image.bigImageURL : null)
            }
          />
          <meta
            name="robots"
            content={
              filtersStorage.allowToIndex
                ? "index, follow"
                : "noindex, nofollow"
            }
          />
          {/* {productsListStorage.currentPage > 0 ? ( */}
          <link
            rel="canonical"
            href={
              currentCategoryStorage.texts.ogUrl ||
              `${window.location.protocol}//${window.location.host}${window.location.pathname}`
            }
          />
          {/* ) : null} */}
          <script type="application/ld+json" id="ldjsonscript">
            {JSON.stringify(
              [
                globalStorage.jsonLdSectionWebSite,
                globalStorage.jsonLdSectionOrganization,
                ...globalStorage.jsonLdSectionStore,
                {
                  "@context": "http://schema.org",
                  "@type": "ItemList",
                  itemListElement: productsListStorage.productsList
                    .map((productID, index) => {
                      const product = productsListStorage.products[productID];
                      if (product) {
                        return {
                          ...product.jsonLdProductItemList,
                          position: index + 1,
                        };
                      }
                    })
                    .filter((v) => !!v),
                },
              ],
              null,
              4
            )}
          </script>
        </MetaTags>
        <div className="collections js-collections pb-10">
          <BreadcrumbsBlock
            homeLink={Core.routing.predefinedRoutes.home}
            homeTitle={t("HOME")}
            currentTitle={h1}
            items={breadcrumbsItems}
          />
          <div className="container mt-10 mt-lg-25">
            <div className="row mb-40">
              <Sidebar>
                <Filters />
                {currentCategoryStorage.relatedLinks.length > 0 &&
                  productsListStorage.currentPage == 0 &&
                  filtersStorage.filtersCount === 0 && (
                    <RelatedLinks
                      items={currentCategoryStorage.relatedLinks}
                      title={t("Related links")}
                    />
                  )}
                {console.log(
                  "WREST",
                  JSON.stringify(filtersStorage.currentFilters)
                )}
                {/* <FeaturedProducts /> */}
                {/* <CustomContent /> */}
                {/* <PromoBlock /> */}
              </Sidebar>

              <div className="collections__body col pb-25">
                <h1 className="h3 mb-10 d-lg-block text-center text-lg-left">
                  {h1}
                  {currentPage > 1
                    ? ` - ${i18next.t("Page")} ${currentPage}`
                    : ""}
                </h1>
                {currentCategoryStorage.texts?.beforeAll && (
                  <div
                    className="container"
                    dangerouslySetInnerHTML={{
                      __html: currentCategoryStorage.texts?.beforeAll,
                    }}
                  />
                )}
                {/* {layoutStorage.currentCategory && */}
                {/*  layoutStorage.currentCategory.texts && ( */}
                {/*    <EditableText */}
                {/*      text={currentCategoryStorage.texts.beforeAll} */}
                {/*      className="category__text-block" */}
                {/*    /> */}
                {/*  )} */}
                <div>
                  <div
                    id="theme-section-collection-head"
                    className="theme-section"
                  >
                    <div
                      data-section-id="collection-head"
                      data-section-type="collection-head"
                    >
                      <div className="collection-head">
                        {layoutStorage.products.allowBigPromoBlock && (
                          <ProductListPromoBlock />
                        )}
                        {/* <div className="mb-15"> */}
                        {/*  <h1 className="h3 mb-10 d-lg-block text-center text-lg-left"> */}
                        {/*    Women's */}
                        {/*  </h1> */}
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                {currentCategoryStorage.texts?.beforeProducts && (
                  <div
                    className="container"
                    dangerouslySetInnerHTML={{
                      __html: currentCategoryStorage.texts?.beforeProducts,
                    }}
                  />
                )}
                {/* {layoutStorage.currentCategory && */}
                {/*  layoutStorage.currentCategory.texts && ( */}
                {/*    <EditableText */}
                {/*      text={layoutStorage.currentCategory.texts.beforeProducts} */}
                {/*      path={`${this.props.location.pathname}.beforeProducts`} */}
                {/*      className="category__text-block" */}
                {/*    /> */}
                {/*  )} */}
                <div
                  id="theme-section-collection-body"
                  className="theme-section"
                >
                  <div
                    data-section-id="collection-body"
                    data-section-type="collection-body"
                    className="mb-35"
                  >
                    <div className="collection-body js-products-view">
                      <CollectionControl />
                      <div className="collection-products">
                        <div className="row w-100">
                          <ProductCardList listField="productsList" />
                        </div>
                      </div>
                    </div>
                    <Pagination />
                  </div>
                  {currentCategoryStorage.texts?.afterProducts &&
                    productsListStorage.currentPage == 0 && (
                      <div
                        className="container"
                        dangerouslySetInnerHTML={{
                          __html: currentCategoryStorage.texts?.afterProducts,
                        }}
                      />
                    )}
                  {/* {layoutStorage.currentCategory && */}
                  {/*  layoutStorage.currentCategory.texts && */}
                  {/*  productsListStorage.currentPage == 0 && ( */}
                  {/*    <EditableText */}
                  {/*      text={currentCategoryStorage.texts.afterProducts} */}
                  {/*      path={`${this.props.location.pathname}.afterProducts`} */}
                  {/*      className="category__text-block" */}
                  {/*      handleChange={(text) => */}
                  {/*        currentCategoryStorage.changeText( */}
                  {/*          "afterProducts", */}
                  {/*          text */}
                  {/*        ) */}
                  {/*      } */}
                  {/*      handleSave={currentCategoryStorage.saveTexts} */}
                  {/*      editable */}
                  {/*    /> */}
                  {/*  )} */}
                  <AdditionalTextBlock container />
                  {currentCategoryStorage.faqLinks?.length > 0 && (
                    <div className="container additional-text">
                      <div
                        itemScope=""
                        itemType="https://schema.org/FAQPage"
                        className="seo-products__faq"
                      >
                        <h2>Часто задаваемые вопросы о {h1} </h2>
                        <div
                          itemScope=""
                          itemProp="mainEntity"
                          itemType="https://schema.org/Question"
                          className="seo-products__faq-question"
                        >
                          <h3 itemProp="name">
                            Какие товары из категории {h1} часто выбирают
                            покупатели?
                          </h3>
                          <div
                            itemScope=""
                            itemProp="acceptedAnswer"
                            itemType="https://schema.org/Answer"
                          >
                            <div
                              itemProp="text"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                paddingBottom: "1rem",
                              }}
                            >
                              {" "}
                              Следующие товары из категории {h1} чаще всего
                              выбирают покупатели в интернет-магазине детской
                              одежды “ALFAKID”:
                              {currentCategoryStorage.faqLinks[0].map((l) => (
                                <a href={l.url}>{l.title}</a>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div
                          itemScope=""
                          itemProp="mainEntity"
                          itemType="https://schema.org/Question"
                          className="seo-products__faq-question"
                        >
                          <h3 itemProp="name">
                            Какие товары из раздела {h1} пользуются
                            популярностью у покупателей?
                          </h3>
                          <div
                            itemScope=""
                            itemProp="acceptedAnswer"
                            itemType="https://schema.org/Answer"
                          >
                            <div
                              itemProp="text"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                paddingBottom: "1rem",
                              }}
                            >
                              {" "}
                              В категории {h1} представлены следующие самые
                              популярные товары -
                              {currentCategoryStorage.faqLinks[1].map((l) => (
                                <a href={l.url}>{l.title}</a>
                              ))}
                            </div>
                          </div>
                        </div>
                        <div
                          itemScope=""
                          itemProp="mainEntity"
                          itemType="https://schema.org/Question"
                          className="seo-products__faq-question"
                        >
                          <h3 itemProp="name">
                            Как можно заказать товары из раздела {h1}?
                          </h3>
                          <div
                            itemScope=""
                            itemProp="acceptedAnswer"
                            itemType="https://schema.org/Answer"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              paddingBottom: "1rem",
                            }}
                          >
                            <div itemProp="text">
                              Преимущества заказа {h1} в интернет-магазине
                              детской одежды с доставкой по Украине.
                              <li>
                                Доставка осуществляется в отделение Новой Почты
                                и курьером Новой Почты по Вашему адресу
                              </li>
                              <li>
                                Вы можете забрать товар из нашего магазина по
                                адресу ул. Куреневская, 18
                              </li>
                            </div>
                          </div>
                        </div>
                        <div
                          itemScope=""
                          itemProp="mainEntity"
                          itemType="https://schema.org/Question"
                          className="seo-products__faq-question"
                        >
                          <h3 itemProp="name">
                            Какие самые популярные бренды товаров в магазине
                            детской одежды alfakid.com?
                          </h3>
                          <div
                            itemScope=""
                            itemProp="acceptedAnswer"
                            itemType="https://schema.org/Answer"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              paddingBottom: "1rem",
                            }}
                          >
                            {currentCategoryStorage.faqLinks[2].map((l) => (
                              <a href={l.url}>{l.title}</a>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* {layoutStorage.products.allowTrendingItems && <TrendingProducts />} */}
          </div>
        </div>
      </Page>
    );
  }
}

Products.propTypes = {};

export default withRouter(withTranslation()(observer(Products)));
